/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mobile_App_Development_Scope_Output5Inputs */

const en_svc_mobile_app_development_scope_output5 = /** @type {(inputs: Svc_Mobile_App_Development_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform strategy`)
};

const ar_svc_mobile_app_development_scope_output5 = /** @type {(inputs: Svc_Mobile_App_Development_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استراتيجية المنصة`)
};

const bn_svc_mobile_app_development_scope_output5 = /** @type {(inputs: Svc_Mobile_App_Development_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্ল্যাটফর্ম স্ট্র্যাটেজি`)
};

const de_svc_mobile_app_development_scope_output5 = /** @type {(inputs: Svc_Mobile_App_Development_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plattformstrategie`)
};

const es_svc_mobile_app_development_scope_output5 = /** @type {(inputs: Svc_Mobile_App_Development_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estrategia de plataforma`)
};

const fr_svc_mobile_app_development_scope_output5 = /** @type {(inputs: Svc_Mobile_App_Development_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stratégie de plateforme`)
};

const pt_svc_mobile_app_development_scope_output5 = /** @type {(inputs: Svc_Mobile_App_Development_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estratégia de plataforma`)
};

const zh_svc_mobile_app_development_scope_output5 = /** @type {(inputs: Svc_Mobile_App_Development_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`平台策略`)
};

const tr_svc_mobile_app_development_scope_output5 = /** @type {(inputs: Svc_Mobile_App_Development_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform stratejisi`)
};

const ru_svc_mobile_app_development_scope_output5 = /** @type {(inputs: Svc_Mobile_App_Development_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стратегия платформы`)
};

const pl_svc_mobile_app_development_scope_output5 = /** @type {(inputs: Svc_Mobile_App_Development_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strategia platformy`)
};

/**
* | output |
* | --- |
* | "Platform strategy" |
*
* @param {Svc_Mobile_App_Development_Scope_Output5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mobile_app_development_scope_output5 = /** @type {((inputs?: Svc_Mobile_App_Development_Scope_Output5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mobile_App_Development_Scope_Output5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mobile_app_development_scope_output5(inputs)
	if (locale === "bn") return bn_svc_mobile_app_development_scope_output5(inputs)
	if (locale === "de") return de_svc_mobile_app_development_scope_output5(inputs)
	if (locale === "es") return es_svc_mobile_app_development_scope_output5(inputs)
	if (locale === "fr") return fr_svc_mobile_app_development_scope_output5(inputs)
	if (locale === "pt") return pt_svc_mobile_app_development_scope_output5(inputs)
	if (locale === "zh") return zh_svc_mobile_app_development_scope_output5(inputs)
	if (locale === "tr") return tr_svc_mobile_app_development_scope_output5(inputs)
	if (locale === "ru") return ru_svc_mobile_app_development_scope_output5(inputs)
	if (locale === "pl") return pl_svc_mobile_app_development_scope_output5(inputs)
	return en_svc_mobile_app_development_scope_output5(inputs)
});
export { svc_mobile_app_development_scope_output5 as "svc_mobile-app-development_SCOPE_output" }